import CityPagePersianas from "../components/CityPagePersianas";

export default function PersianasMarbella() {
  return (
    <CityPagePersianas
      name="Marbella"
      slug="marbella"
      cp="29600-29604"
      poblacion={160000}
      zonaGeo="Costa del Sol Occidental"
      lat={36.5099}
      lng={-4.8826}
      zonas={[
        "Centro Histórico",
        "Puerto Banús",
        "Nueva Andalucía",
        "San Pedro de Alcántara",
        "Las Chapas",
        "Elviria",
        "Los Monteros",
        "Río Real",
        "Cabopino",
        "Sierra Blanca",
      ]}
      landmarks={[
        "Plaza de los Naranjos",
        "Puerto Banús",
        "Paseo Marítimo",
        "Avenida Ricardo Soriano",
        "Casco Antiguo",
      ]}
      municipiosLimitrofes={[
        "Ojén",
        "Istán",
        "Benahavís",
        "Estepona",
        "Mijas",
      ]}
      festivalLocal="Feria y Fiestas de San Bernabé, 11 de junio"
      contextoTipologico="Villas premium con grandes ventanales en Puerto Banús y Sierra Blanca, urbanizaciones de lujo Las Chapas-Elviria, casco antiguo con persianas tradicionales, exposición salina intensa."
      isCoreZone={true}
    />
  );
}